"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.computeQuotePaymentMentions = exports.computeInvoicePaymentMentions = void 0;
const computeInvoicePaymentMentions = ({ clientType, }) => {
    if (clientType === 'PRIVATE_INDIVIDUAL') {
        return 'INVOICE_B2C_LATE_PAYMENT';
    }
    return 'INVOICE_LATE_PAYMENT';
};
exports.computeInvoicePaymentMentions = computeInvoicePaymentMentions;
const computeQuotePaymentMentions = ({ clientType, }) => {
    if (clientType === 'PRIVATE_INDIVIDUAL') {
        return 'QUOTE_B2C_LATE_PAYMENT';
    }
    return 'QUOTE_LATE_PAYMENT';
};
exports.computeQuotePaymentMentions = computeQuotePaymentMentions;
